export default __webpack_public_path__ + "static/media/clouds.ffc03648.jpg";